import React from 'react';
import FooterContent from './FooterContent';
import FooterBottom from './FooterBottom';
import '../../../styles/components/sections/Footer.css';

const Footer = ({ carWashes, scrollToSection }) => {
  return (
    <footer className="footer">
      <div className="footer-waves">
        <div className="wave wave1"></div>
        <div className="wave wave2"></div>
        <div className="wave wave3"></div>
      </div>
      
      <div className="container">
        <FooterContent 
          carWashes={carWashes}
          scrollToSection={scrollToSection}
        />
        <FooterBottom />
      </div>
    </footer>
  );
};

export default Footer;
